var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertVersionnDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 8C0.5 3.8525 3.8525 0.5 8 0.5C12.1475 0.5 15.5 3.8525 15.5 8C15.5 12.1475 12.1475 15.5 8 15.5C3.8525 15.5 0.5 12.1475 0.5 8ZM10.1675 11.225C10.46 11.5175 10.9325 11.5175 11.225 11.225C11.51 10.9325 11.51 10.4525 11.225 10.1675L9.05751 8L11.225 5.8325C11.5175 5.54 11.5175 5.0675 11.225 4.775C10.9325 4.4825 10.46 4.4825 10.1675 4.775L8.00001 6.9425L5.83251 4.775C5.54001 4.4825 5.06751 4.4825 4.77501 4.775C4.63457 4.91512 4.55564 5.10536 4.55564 5.30375C4.55564 5.50214 4.63457 5.69238 4.77501 5.8325L6.94251 8L4.77501 10.1675C4.63457 10.3076 4.55564 10.4979 4.55564 10.6962C4.55564 10.8946 4.63457 11.0849 4.77501 11.225C5.06751 11.5175 5.54001 11.5175 5.83251 11.225L8.00001 9.0575L10.1675 11.225Z",
    fill: "#F38D33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertVersionnDelete);
export default __webpack_public_path__ + "static/media/expert-versionn-delete.62c5762521b123c187af978aaee2c12a.svg";
export { ForwardRef as ReactComponent };